<template>
  <div class="campaign_analytics_dialog">
    <el-dialog custom-class="with-title x-large" :visible.sync="visible" :before-close="beforeClose">
      <div class="custom-title" layout layout-align="start-center" slot="title">
        キャンペーン分析
        <icon
          class="mr-x1 ml-x2"
          :name="campaign.name ?? undefined"
          :pictureUrl="campaign.pictureUrl ?? undefined"
          :iconType="campaign.iconType"
        ></icon>
        <div>{{ campaign.name }}</div>
      </div>
      <div v-loading="loading">
        <div v-if="isCampaignCollectionCompleted">
          <div class="mb-x2">
            <div class="message message-info">分析データの最終集計が完了しました。</div>
          </div>
        </div>
        <div v-else-if="isCampaignFinalCollection">
          <div class="mb-x2">
            <div class="message message-info">
              分析データの最終集計中です。<br />{{ collectCompletedAt }}
              ごろまでに最終的なデータが反映されます。応募件数により、反映が遅れる場合があります。
            </div>
          </div>
        </div>
        <div v-else-if="isRepostCampaignBeforeCollect">
          <div class="mb-x2">
            <div class="message message-info">
              応募収集URLを設定すると、応募の収集を開始します。設定されるまで応募は収集されません。<br />応募は30分間隔で収集されます。URLの設定時点から7日より前の応募は収集されないため、早めに設定してください。
            </div>
          </div>
        </div>
        <el-row class="mb-x2" :gutter="20">
          <el-col :span="8" v-if="campaign.type === 'keyword' || campaign.type === 'old_web_instantwin'">
            <el-select class="prize-select mr-x2" v-model="prizeId" @change="getAnalyticByPrize">
              <el-option
                v-for="(prize, index) in prizeOptions"
                :value="prize.id"
                :label="prize.name"
                :key="index"
              ></el-option>
            </el-select>
          </el-col>
          <el-col class="date-time-picker" :span="8">
            <analytics-period-picker
              v-model="dateTimeRange"
              :campaign-start-datetime="campaignStartDatetime"
              :campaign-end-datetime="campaignEndDatetime"
              @change="changeDatetimerange"
            ></analytics-period-picker>
          </el-col>
        </el-row>
        <el-row class="mb-x2" :gutter="20">
          <el-col :span="8">
            <analytics-total
              metric="応募数"
              :value="entryCount"
              tooltip="キャンペーンへの応募数です。この数値には、重複応募も含まれます。"
            ></analytics-total>
          </el-col>
          <el-col :span="8">
            <analytics-total
              metric="応募者数"
              :value="applicantCount"
              tooltip="キャンペーンへ応募したアカウントの数です。"
            ></analytics-total>
          </el-col>
          <el-col :span="8">
            <analytics-total metric="新規応募者数" :value="newApplicantCount">
              <template #tooltip-content>
                <el-tooltip class="ml-x1" placement="top">
                  <div slot="content">
                    同一開催アカウントで過去に実施したキャンペーン<br />
                    (WEBインスタントウィン含む、インスタントウィン除く)<br />
                    に応募した実績のない応募者の数です。
                  </div>
                  <i class="mr-x2 mdi mdi-help-circle"></i
                ></el-tooltip>
              </template>
            </analytics-total>
          </el-col>
        </el-row>
        <el-row class="mb-x2" :gutter="20">
          <el-col :span="8">
            <analytics-total
              metric="フォロワー増減数"
              :value="followerUpDown"
              tooltip="キャンペーン開催アカウントのフォロワー数の増減です。"
              :isUpDown="true"
            ></analytics-total>
          </el-col>
          <el-col :span="8">
            <analytics-total metric="新規獲得フォロワー" :value="newFollowerCount">
              <template #tooltip-content>
                <el-tooltip class="ml-x1" placement="top">
                  <div slot="content">
                    応募者のうち、キャンペーン実施後にフォロワーとなった数です。<br />
                    キャンペーンに応募していないXアカウントは含まれません。
                  </div>
                  <i class="mr-x2 mdi mdi-help-circle"></i
                ></el-tooltip>
              </template>
            </analytics-total>
          </el-col>
          <el-col :span="8">
            <analytics-total metric="推定リーチ" :value="reachCount">
              <template #tooltip-content>
                <el-tooltip class="ml-x1" placement="top">
                  <div slot="content">
                    応募者ごとのフォロワー数合計です。<br />
                    応募ポストが応募者のフォロワー全員にリーチした場合を仮定した推測値です。
                  </div>
                  <i class="mr-x2 mdi mdi-help-circle"></i
                ></el-tooltip>
              </template>
            </analytics-total>
          </el-col>
        </el-row>
        <el-row class="mb-x3" :gutter="20">
          <el-col :span="8">
            <analytics-total metric="当選数" :value="winnerCount"></analytics-total>
          </el-col>
        </el-row>
        <el-tabs v-model="activeTab" @tab-click="changeTab">
          <el-tab-pane class="graph-container" label="キャンペーン" name="campaigns">
            <div class="mb-x3" layout layout-align="space-between-center">
              <div layout>
                <div layout="column">
                  <label class="nav_label">値1</label>
                  <el-select v-model="value1" @change="changeChart('value1')">
                    <el-option
                      v-for="(item, index) in values"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <div class="ml-x2" layout="column">
                  <label class="nav_label">値2</label>
                  <el-select v-model="value2" @change="changeChart('value2')">
                    <el-option
                      v-for="(item, index) in values"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div>
                <div class="nav_label">&nbsp;</div>
                <el-switch
                  v-model="isBeginAtZero"
                  active-text="0から表示"
                  :active-value="true"
                  :inactive-value="false"
                  @change="changeIsBeginAtZero"
                ></el-switch>
              </div>
              <div>
                <div class="nav_label">&nbsp;</div>
                <div layout layout-align="space-around-center">
                  <el-button-group>
                    <el-button
                      :type="interval === item.value ? 'primary' : 'default'"
                      v-for="item in intervals"
                      :key="item.value"
                      @click="changeInterval(item.value)"
                      >{{ item.text }}</el-button
                    >
                  </el-button-group>
                  <div class="ml-x1">
                    <el-tooltip placement="top" content="CSVダウンロード">
                      <csv-download :download="downloadCsv" text="'"></csv-download>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
            <div class="message message-info" v-if="!data.length">データがありません。</div>
            <div class="message message-info" v-else-if="value1 === '' && value2 === ''">
              値1または値2を選択してください。
            </div>
            <div class="body" v-else>
              <analytics-chart-vertical
                ref="chart"
                :data="chartData"
                :xAxis="labels"
                :interval="interval"
                :isBeginAtZero="isBeginAtZero"
              ></analytics-chart-vertical>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="'応募者のフォロワー数'" name="applicantFollowers">
            <div class="graph-container">
              <div class="mb-x2" layout layout-align="end-center">
                <el-tooltip placement="top" content="CSVダウンロード">
                  <csv-download :download="downloadCsvFollowers" text=""></csv-download>
                </el-tooltip>
              </div>
              <div class="message message-info" v-if="isEmptyApplicantFollower">データがありません。</div>
              <div class="div" v-else>
                <analytics-chart-doughnut
                  ref="chart"
                  :data="followerData"
                  :chartStyles="chartStyles"
                  :height="450"
                ></analytics-chart-doughnut>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="mt-x2" :gutter="20"></div>
        <div class="public-setting mt-x1" layout layout-align="start-center">
          <div class="public-switch">
            <el-switch
              v-model="isPublicAnalyticsPage"
              active-text="分析結果の共有"
              :active-value="1"
              :inactive-value="0"
              @change="changePublicAnalyticsFlags('分析結果の共有')"
            ></el-switch>
            <el-tooltip placement="top">
              <div slot="content">キャンペーン分析ページを外部公開します。</div>
              <i class="mdi mdi-help-circle"></i>
            </el-tooltip>
          </div>
          <div class="public-url" v-if="isPublicAnalyticsPage">{{ publicPageUrl }}</div>
          <el-button class="ml-x1" v-if="isPublicAnalyticsPage" @click="copyToClipboard(publicPageUrl)"
            >コピー</el-button
          >
        </div>
        <div class="public-setting mt-x1" layout layout-align="start-center">
          <div class="public-switch">
            <el-switch
              v-model="isPublicAnalyticsApi"
              active-text="APIとして公開"
              :active-value="1"
              :inactive-value="0"
              @change="changePublicAnalyticsFlags('APIとして公開')"
            ></el-switch>
            <el-tooltip placement="top">
              <div slot="content">
                キャンペーン分析データをAPIとして外部公開します。<br />entry_countが応募数、applicant_countが応募者数となり、1時間ごとにデータが更新されます。
              </div>
              <i class="mdi mdi-help-circle"></i>
            </el-tooltip>
          </div>
          <div class="public-url" v-if="isPublicAnalyticsApi">{{ publicApiUrl }}</div>
          <el-button class="ml-x1" v-if="isPublicAnalyticsApi" @click="copyToClipboard(publicApiUrl)">コピー</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.campaign_analytics_dialog {
  :deep(.el-input__inner) {
    height: $spacing-unit * 5;
  }

  :deep(.el-input) {
    width: $spacing-unit * 18;

    &.el-input--suffix {
      min-width: $spacing-unit * 22;
    }
  }

  :deep(.el-tabs__content) {
    max-height: none;
  }

  :deep(.graph-container) {
    padding: $spacing-unit ($spacing-unit * 3);
    border: 1px solid $border-color;
  }

  :deep(.body) {
    margin: 0 ($spacing-unit * 3);
  }

  :deep(.custom-title) {
    color: $text-color-white;
  }

  :deep(.prize-select),
  :deep(.prize-select .el-input) {
    width: 100%;
  }

  :deep(.date-time-picker) {
    .el-range-editor {
      width: 100% !important;
    }

    float: right;
  }

  :deep(.mdi-help-circle) {
    margin-left: $spacing-unit;
    font-size: 20px;
  }

  .public-setting {
    height: $spacing-unit * 4;
  }

  .public-switch {
    width: $spacing-unit * 25;
  }

  .public-url {
    width: $spacing-unit * 60;
    padding: 0 $spacing-unit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background-color: $background-color;
  }
}
</style>

<script lang="ts">
import moment from 'moment-timezone'
import { mapState } from 'pinia'
import { defineComponent } from 'vue'

import AnalyticsChartDoughnut from '@/client/components/_atoms/analytics_chart_doughnut'
import AnalyticsChartVertical from '@/client/components/_atoms/analytics_chart_vertical'
import AnalyticsPeriodPicker from '@/client/components/_atoms/analytics_period_picker'
import AnalyticsTotal from '@/client/components/_atoms/analytics_total'
import Icon from '@/client/components/_atoms/basic_icon'
import CsvDownload from '@/client/components/_atoms/csv_download'
import { CAMPAIGN_STATUS } from '@/client/constant'
import api from '@/client/core/api'
import Util from '@/client/core/util'
import {
  RepostCollectionAlertState,
  resolveRepostCollectionAlertState
} from '@/client/features/campaigns/utils/repostCollectionAlert'
import { TrackingService } from '@/client/services'
import { useCampaignStore } from '@/client/store/useCampaignStore'
import { getAnalyticsDefaultPeriod } from '@/common/utils/analytics_period'
import type { APIGetTwitterCampaignAnalyticsFollowersResponse } from '@/server/api/twitter_campaign_analytics/get_followers.api'
import { TGetCampaignAnalyticsId } from '@/typings/api/twitter_campaign_analytics.type'

type CampaignAnalytic = TGetCampaignAnalyticsId['data'][number]

type TimeRange = { start: number; end: number }

type AnalyticsData = {
  applicant: (number | null)[]
  reach: (number | null)[]
  follower: (number | null)[]
  entry: (number | null)[]
  newApplicant: (number | null)[]
  newFollower: (number | null)[]
  winner: (number | null)[]
}

type ChartDataItem = { metric: string; label: string | undefined; data: (number | null)[] }

type PrizeOption = { name: string; id: number | null }

export default defineComponent({
  components: {
    Icon,
    AnalyticsChartVertical,
    AnalyticsChartDoughnut,
    AnalyticsPeriodPicker,
    AnalyticsTotal,
    CsvDownload
  },
  data() {
    return {
      activeTab: 'campaigns',
      visible: false,
      loading: true,
      campaignId: null as number | null,
      chartData: [] as ChartDataItem[],
      followerData: [] as APIGetTwitterCampaignAnalyticsFollowersResponse[],
      labels: [] as string[],
      interval: 'hour',
      value1: 'follower',
      value2: 'applicant',
      data: [] as CampaignAnalytic[],
      reachCount: 0,
      applicantCount: 0 as number | null,
      followerUpDown: 0,
      entryCount: 0 as number | null,
      newApplicantCount: 0 as number | null,
      newFollowerCount: 0 as number | null,
      winnerCount: 0 as number | null,
      prizeOptions: [{ name: '全ての応募グループ', id: null }] as PrizeOption[],
      prizeId: null as number | null,
      dateTimeRange: [] as (string | Date)[],
      defaultDateTimeRange: [] as (string | Date)[],
      campaignStartDatetime: null as string | null,
      campaignEndDatetime: null as string | null,
      hash: '',
      isBeginAtZero: false,
      chartStyles: {
        margin: '0 auto'
      },
      isPublicAnalyticsPage: 0,
      isPublicAnalyticsApi: 0,
      entryActionType: '',
      hasTweetPostUrl: false
    }
  },
  computed: {
    ...mapState(useCampaignStore, ['campaigns']),

    campaign() {
      const campaigns = this.campaigns.find(value => value.id === this.campaignId)

      return {
        id: campaigns ? campaigns.id : null,
        name: campaigns ? campaigns.title : null,
        status: campaigns ? campaigns.status : null,
        pictureUrl: campaigns?.account?.pictureUrl ?? null,
        type: campaigns ? campaigns.type : null,
        iconType: 'twitter',
        startDatetime: campaigns ? campaigns.startDatetime : null,
        endDatetime: campaigns ? campaigns.endDatetime : null
      }
    },

    repostCollectionAlertState() {
      return resolveRepostCollectionAlertState({
        type: this.campaign.type,
        entryActionType: this.entryActionType,
        status: this.campaign.status,
        hasTweetPostUrl: this.hasTweetPostUrl
      })
    },

    isRepostCampaignBeforeCollect() {
      return this.repostCollectionAlertState === RepostCollectionAlertState.BEFORE_COLLECTION
    },

    isCampaignFinalCollection() {
      return this.campaign.status === CAMPAIGN_STATUS.DURING_FINAL_COLLECTION
    },

    isCampaignCollectionCompleted() {
      return this.campaign.status === CAMPAIGN_STATUS.COLLECTION_COMPLETED
    },

    collectCompletedAt() {
      // フォロワー取得バッチが深夜1時に実行されるため、次のバッチ実行日の午前10時を表示する
      return moment(this.campaign.endDatetime).subtract(1, 'hours').add(1, 'days').format('YYYY年MM月DD日 10:00')
    },

    values() {
      if (this.interval === 'hour') {
        return [
          { label: '指定なし', value: '' },
          { label: '応募数', value: 'entry' },
          { label: '応募者数', value: 'applicant' },
          { label: '新規応募者数', value: 'newApplicant' },
          { label: '当選数', value: 'winner' },
          { label: '推定リーチ', value: 'reach' },
          { label: 'フォロワー', value: 'follower' }
        ]
      }

      return [
        { label: '指定なし', value: '' },
        { label: '応募数', value: 'entry' },
        { label: '応募者数', value: 'applicant' },
        { label: '新規応募者数', value: 'newApplicant' },
        { label: '当選数', value: 'winner' },
        { label: '推定リーチ', value: 'reach' },
        { label: 'フォロワー', value: 'follower' },
        { label: '新規獲得フォロワー', value: 'newFollower' }
      ]
    },

    intervals() {
      return [
        { text: '1時間', value: 'hour' },
        { text: '1日', value: '1_day' },
        { text: '7日', value: '7_day' },
        { text: '1ヶ月', value: '1_month' }
      ]
    },

    time_range(): TimeRange[] {
      const timeRange: TimeRange[] = []

      if (!this.data.length) {
        return timeRange
      }

      const addNumber = Number(this.interval.match(/\d+/g))

      let timeEnd
      let timeStart = moment(moment(this.data[0].datetime).format('YYYY-MM-DD 00:00:00')).unix()
      const endDateUnix = moment(moment(this.data[this.data.length - 1].datetime).format('YYYY-MM-DD HH:mm:00')).unix()

      while (timeStart < endDateUnix) {
        if (
          this.interval === '1_day' ||
          this.interval === '7_day' ||
          this.interval === '14_day' ||
          this.interval === '28_day'
        ) {
          // 日数のunix値: 日数 x 一日のunix値 (一日のunix値: 86400)
          timeEnd = timeStart + addNumber * 86400 - 1
        } else if (this.interval === '1_month') {
          timeEnd = moment.unix(timeStart).add(addNumber, 'months').startOf('month').unix() - 1
        }

        if (timeEnd > endDateUnix) {
          timeEnd = endDateUnix
        }

        timeRange.push({
          start: timeStart,
          end: timeEnd
        })

        timeStart = timeEnd + 1
      }

      if (timeRange.length) {
        timeRange[0].start = moment(this.data[0].datetime).unix()
      } else {
        timeRange.push({ start: endDateUnix, end: endDateUnix })
      }

      return timeRange
    },

    time_range_for_label(): TimeRange[] {
      const timeRange: TimeRange[] = []

      if (!this.data.length) {
        return timeRange
      }

      const addNumber = Number(this.interval.match(/\d+/g))

      let timeEnd
      let timeStart = moment(moment(this.data[0].datetime).format('YYYY-MM-DD 00:00:00')).unix()
      const endDateUnix = moment(moment(this.data[this.data.length - 1].datetime).format('YYYY-MM-DD HH:mm:00')).unix()

      while (timeStart < endDateUnix) {
        if (
          this.interval === '1_day' ||
          this.interval === '7_day' ||
          this.interval === '14_day' ||
          this.interval === '28_day'
        ) {
          // 日数のunix値: 日数 x 一日のunix値 (一日のunix値: 86400)
          timeEnd = timeStart + addNumber * 86400 - 1
        } else if (this.interval === '1_month') {
          timeEnd = moment.unix(timeStart).add(addNumber, 'months').startOf('month').unix() - 1
        }

        if (timeEnd > endDateUnix) {
          timeEnd = endDateUnix
        }

        timeRange.push({
          start: timeStart,
          end: timeEnd
        })

        timeStart = timeEnd + 1
      }

      if (timeRange.length) {
        timeRange[0].start = moment(this.data[0].datetime).unix()
      } else {
        timeRange.push({ start: endDateUnix, end: endDateUnix })
      }

      return timeRange
    },

    analytics(): AnalyticsData {
      const data: AnalyticsData = {
        applicant: [],
        reach: [],
        follower: [],
        entry: [],
        newApplicant: [],
        newFollower: [],
        winner: []
      }

      if (!this.data.length) {
        return data
      }

      if (this.interval === 'hour') {
        const lastIndex = this.data.length - 1
        this.data.forEach((value, index) => {
          if (index !== lastIndex) {
            data.reach.push(value.reach_count)
            data.follower.push(value.follower_count)
            data.newFollower.push(value.new_follower_count)
            data.applicant.push(value.applicant_count)
            data.entry.push(value.entry_count)
            data.newApplicant.push(value.new_applicant_count)
            data.winner.push(value.winner_count)
          }
        })
        return data
      }

      const endDateUnix = moment(this.data[this.data.length - 1].datetime)
        .startOf('minute')
        .unix()
      this.time_range.forEach((time, index) => {
        // 該当する期間の分析データを取得
        let analytics = this.data
          .filter(analytic => {
            return moment(analytic.datetime).unix() >= time.start && moment(analytic.datetime).unix() <= time.end
          })
          .map(analytic => analytic)

        if (this.interval === '1_day') {
          const momentDate = index < this.time_range.length - 1 ? moment.unix(time.start) : moment.unix(time.end)
          const datetime = momentDate.startOf('hour').format('YYYY-MM-DD HH:mm')

          data.follower.push(this.getValueByHour(analytics, datetime, 'follower_count'))
          data.newFollower.push(this.getValueByHour(analytics, datetime, 'new_follower_count'))
          data.reach.push(this.getValueByHour(analytics, datetime, 'reach_count'))
        } else {
          data.reach.push(this.getValueByPeriod(analytics, 'reach_count'))
          data.follower.push(this.getValueByPeriod(analytics, 'follower_count'))
          data.newFollower.push(this.getValueByPeriod(analytics, 'new_follower_count'))
        }

        if (time.end === endDateUnix) {
          analytics = analytics.filter(v => moment(v.datetime).unix() !== endDateUnix)
        }

        data.applicant.push(this.getTotal(analytics, 'applicant_count'))
        data.entry.push(this.getTotal(analytics, 'entry_count'))
        data.newApplicant.push(this.getTotal(analytics, 'new_applicant_count'))
        data.winner.push(this.getTotal(analytics, 'winner_count'))
      })

      return data
    },

    isEmptyApplicantFollower() {
      return this.followerData.every(follower => follower.count === 0)
    },

    publicPageUrl() {
      return `https://${window.location.host}/publics/twitter_campaign_analytics?hash=${this.hash}`
    },

    publicApiUrl() {
      if (this.prizeId) {
        return `https://${window.location.host}/api/publics/applicant_count?hash=${this.hash}&prizeId=${this.prizeId}`
      }

      return `https://${window.location.host}/api/publics/applicant_count?hash=${this.hash}`
    }
  },
  methods: {
    /**
     * ダイアログを開く
     */
    async open(campaignId: number) {
      this.activeTab = 'campaigns'
      this.visible = true
      this.loading = true
      this.campaignId = campaignId
      this.value1 = 'follower'
      this.value2 = 'applicant'
      this.interval = '1_day'
      this.labels = []
      this.chartData = []
      this.followerData = []
      this.prizeId = null
      this.prizeOptions = [{ name: '全ての応募グループ', id: null }]
      this.entryActionType = ''
      this.hasTweetPostUrl = false
      try {
        await this.getCampaign()
        await this.getCampaignAnalyticsId(campaignId)
        await this.getPrizes()
        await this.getApplicantFollower()
        this.changeChart('')
        this.loading = false
      } catch {
        this.loading = false
        this.alert()
        this.close()
      }
    },

    /**
     * キャンペーンデータを取得
     */
    async getCampaign() {
      if (!this.campaignId) {
        return
      }

      const result = await api.get('/campaigns/' + this.campaignId)

      if (!result || !result.data) {
        return
      }

      const campaign: any = result.data
      const defaultPeriod = getAnalyticsDefaultPeriod(campaign.startDatetime, campaign.endDatetime)
      this.dateTimeRange = defaultPeriod
      this.defaultDateTimeRange = defaultPeriod
      this.campaignStartDatetime = campaign.startDatetime
      this.campaignEndDatetime = campaign.endDatetime
      this.hash = campaign.hash
      this.isPublicAnalyticsPage = campaign.isPublicAnalyticsPage
      this.isPublicAnalyticsApi = campaign.isPublicAnalyticsApi
      this.entryActionType = campaign.setting ? campaign.setting.entryActionType : ''
      this.hasTweetPostUrl = Boolean(campaign.hasTweetPostUrl)
    },

    /**
     * 日時を変更する
     */
    async changeDatetimerange(value: any) {
      TrackingService.sendEvent('select:キャンペーン分析（X）|カレンダー')

      if (!value) {
        this.dateTimeRange = this.defaultDateTimeRange
      } else {
        this.dateTimeRange = value
      }
      this.loading = true
      await this.getCampaignAnalyticsId(this.campaignId)
      this.changeChart('')
      await this.getApplicantFollower()
      this.loading = false

      if (!this.dateTimeRange) {
        this.dateTimeRange = this.defaultDateTimeRange
      }
    },

    /**
     * 応募グループ分析データの取得
     */
    async getAnalyticByPrize(): Promise<void> {
      TrackingService.sendEvent('select:キャンペーン分析（X）|全ての応募グループ')

      this.loading = true
      await this.getCampaignAnalyticsId(this.campaignId)
      this.changeChart('')
      await this.getApplicantFollower()
      this.loading = false
    },

    /**
     * Get applicant follower
     */
    async getApplicantFollower() {
      if (!this.campaignId) {
        return
      }

      const params: any = {}

      if (
        this.prizeId &&
        this.campaign.type !== null &&
        ['keyword', 'old_web_instantwin'].includes(this.campaign.type)
      ) {
        params.prizeId = this.prizeId
      }

      if (this.dateTimeRange && this.dateTimeRange.length) {
        params.startDatetime = moment(this.dateTimeRange[0]).format('YYYY-MM-DD')
        params.endDatetime = moment(this.dateTimeRange[1]).format('YYYY-MM-DD')
      }

      const result = await api.get('/twitter_campaign_analytics/' + this.campaignId + '/followers', { params })

      if (!result || !result.data) {
        this.alert()
        this.close()
        return
      }

      this.followerData = result.data
    },

    /**
     * ダイアログを閉じる
     */
    close() {
      this.visible = false
      this.loading = true
      this.campaignId = null
      this.dateTimeRange = []
    },

    /**
     * ダイアログを閉じる
     */
    beforeClose() {
      TrackingService.sendEvent('click:キャンペーン分析（X）|閉じる')

      this.visible = false
      this.dateTimeRange = []
      this.defaultDateTimeRange = []
    },

    /**
     * ソートする値の変更イベント
     */
    changeChart(selectedValue: string) {
      if (selectedValue === 'value1') {
        TrackingService.sendEvent('select:キャンペーン分析（X）|キャンペーン|値1')
      } else if (selectedValue === 'value2') TrackingService.sendEvent('select:キャンペーン分析（X）|キャンペーン|値2')

      this.chartData = this.getChartData()
      this.labels = this.getLabels()
    },

    changeInterval(interval: string) {
      this.interval = interval
      if (interval === 'hour') {
        TrackingService.sendEvent('click:キャンペーン分析（X）|キャンペーン|1時間')

        if (this.value1 === 'newFollower') {
          this.value1 = 'follower'
        }
        if (this.value2 === 'newFollower') {
          this.value2 = 'applicant'
        }
      } else if (interval === '1_day') {
        TrackingService.sendEvent('click:キャンペーン分析（X）|キャンペーン|1日')
      } else if (interval === '7_day') {
        TrackingService.sendEvent('click:キャンペーン分析（X）|キャンペーン|7日')
      } else TrackingService.sendEvent('click:キャンペーン分析（X）|キャンペーン|1ヶ月')

      this.changeChart('')
    },

    getLabels(): string[] {
      let labels: string[] = []

      switch (this.interval) {
        case 'hour':
          labels = []
          this.data.slice(0, -1).forEach(value => {
            const date = moment(value.datetime).startOf('hour').format('YYYY/MM/DD HH:mm')
            labels.push(date)
          })
          return labels
        case '1_day':
          return this.time_range_for_label.map((time, index) => {
            if (index === this.time_range_for_label.length - 1) {
              return moment.unix(time.end).startOf('hour').format('YYYY/MM/DD')
            }

            return moment.unix(time.start).startOf('hour').format('YYYY/MM/DD')
          })
        case '7_day':
        case '14_day':
        case '28_day':
          return this.time_range_for_label.map(time => {
            return `${moment.unix(time.start).format('MM/DD')}-${moment.unix(time.end).format('MM/DD')}`
          })
        case '1_month':
          return this.time_range_for_label.map(time => {
            return moment.unix(time.start).format('YYYY/MM')
          })
        default:
          return []
      }
    },

    getChartData(): ChartDataItem[] {
      const data: ChartDataItem[] = []

      if (this.value1) {
        const label = this.values.find(value => value.value === this.value1)
        data.push({
          metric: this.value1,
          label: label?.label,
          data: this.analytics[this.value1]
        })
      }

      if (this.value2) {
        const label = this.values.find(value => value.value === this.value2)
        data.push({
          metric: this.value2,
          label: label?.label,
          data: this.analytics[this.value2]
        })
      }

      return data
    },

    /**
     * CSVファイルをダウンロード
     */
    downloadCsv() {
      TrackingService.sendEvent('click:キャンペーン分析（X）|キャンペーン|CSVダウンロード')

      const filename = `${this.campaign.name}_分析`

      const data: (string | number | null)[][] = []

      let header = [
        '日付',
        '応募数',
        '応募者数',
        '新規応募者数',
        '当選数',
        '推定リーチ',
        'フォロワー',
        '新規獲得フォロワー'
      ]

      if (this.interval === 'hour') {
        header = ['日付', '応募数', '応募者数', '新規応募者数', '当選数', '推定リーチ', 'フォロワー']
      }

      data.push(header)

      this.labels.forEach((label, index) => {
        if (this.interval === '1_day') {
          label = moment(label).startOf('hour').format('YYYY/MM/DD')
        }

        const applicant = isNaN(Number(this.analytics.applicant[index])) ? null : this.analytics.applicant[index]
        const reach = isNaN(Number(this.analytics.reach[index])) ? null : this.analytics.reach[index]
        const follower = isNaN(Number(this.analytics.follower[index])) ? null : this.analytics.follower[index]
        const entry = isNaN(Number(this.analytics.entry[index])) ? null : this.analytics.entry[index]
        const newApplicant = isNaN(Number(this.analytics.newApplicant[index]))
          ? null
          : this.analytics.newApplicant[index]
        const newFollower = isNaN(Number(this.analytics.newFollower[index])) ? null : this.analytics.newFollower[index]
        const winner = isNaN(Number(this.analytics.winner[index])) ? null : this.analytics.winner[index]

        let values = [label, entry, applicant, newApplicant, winner, reach, follower, newFollower]

        if (this.interval === 'hour') {
          values = [label, entry, applicant, newApplicant, winner, reach, follower]
        }

        data.push(values)
      })

      return { filename, data }
    },

    /**
     * CSVダウンロード
     */
    downloadCsvFollowers() {
      TrackingService.sendEvent('click:キャンペーン分析（X）|応募者のフォロワー数|CSVダウンロード')

      const filename = `${this.campaign.name}_応募者のフォロワー分析`
      const data: (string | number)[][] = []
      const header = ['ラベル', '値', '割合']

      data.push(header)
      const totalData = this.followerData.map(follower => follower.count).reduce((count, current) => count + current, 0)

      this.followerData.forEach(follower => {
        const percentage = !totalData ? 0 : Math.round((follower.count / totalData) * Math.pow(100, 2)) / 100
        data.push([follower.label, follower.count, percentage])
      })

      return { filename, data }
    },

    /**
     * キャンペーン分析を取得
     */
    async getCampaignAnalyticsId(campaignId: number | null) {
      if (campaignId === null) {
        return
      }

      let params: any = {}

      if (
        this.prizeId &&
        this.campaign.type !== null &&
        ['keyword', 'old_web_instantwin'].includes(this.campaign.type)
      ) {
        params = {
          prizeId: this.prizeId
        }
      }

      if (this.dateTimeRange.length) {
        params.startDatetime = moment(this.dateTimeRange[0]).format('YYYY-MM-DD')
        params.endDatetime = moment(this.dateTimeRange[1]).format('YYYY-MM-DD')
      }

      const response = await api.get(`/twitter_campaign_analytics/${campaignId}`, { params })

      if (!response.data) {
        this.alert()
        this.close()
        return
      }

      this.data = response.data

      const firstFollowerCount = this.getFirstValueExceptNull(this.data, 'follower_count')
      const firstReachCount = this.data[0]?.reach_count ?? 0
      const columnData = this.data.slice(0, this.data.length - 1)

      this.applicantCount = this.getTotal(columnData, 'applicant_count')
      this.newApplicantCount = this.getTotal(columnData, 'new_applicant_count')
      this.newFollowerCount = this.getNewFollowerCount()
      this.followerUpDown = this.getLastValue(this.data, 'follower_count') - firstFollowerCount
      this.reachCount = this.getLastValue(this.data, 'reach_count') - firstReachCount
      this.entryCount = this.getTotal(columnData, 'entry_count')
      this.winnerCount = this.getTotal(columnData, 'winner_count')
    },

    /**
     * 応募グループ一覧を取得する
     */
    async getPrizes() {
      const params = {
        campaignId: this.campaignId,
        forCsv: 1
      }

      const result = await api.get(`/twitter_campaign_prizes`, { params })

      if (!result || !result.data || !result.data.prizes) {
        return
      }

      const prizes = result.data.prizes.map(prize => ({ id: prize.id, name: prize.name }))

      this.prizeOptions = [...this.prizeOptions, ...prizes]
    },

    getTotal(data: CampaignAnalytic[], metric: string) {
      return this.addition(this.getMetricArray(data, metric))
    },

    /**
     * 分析データから値を取得
     */
    getMetricValue(insight: any, metric: string): any | null {
      return isNaN(insight[metric]) ? null : insight[metric]
    },

    /**
     * 分析データから値の配列を取得
     */
    getMetricArray(insights: any[], metric: string): any[] {
      return insights.map(insight => this.getMetricValue(insight, metric))
    },

    /**
     * 数値変換
     */
    toNumber(value: any): number {
      return !isNaN(value) ? value : 0
    },

    /**
     * 足し算
     */
    addition(numbers: number[] = []): number | null {
      const values = numbers.filter(v => v !== null)

      if (!values.length) {
        return null
      }

      return numbers.map(v => this.toNumber(v)).reduce((a, c) => a + c, 0)
    },

    getNewFollowerCount() {
      if (!this.data.length) {
        return null
      }

      const counts = this.data.flatMap(analytic => (analytic.new_follower_count ? [analytic.new_follower_count] : []))

      if (moment(this.data[0].datetime).isSame(this.campaign.startDatetime, 'day')) {
        return counts.length ? counts[counts.length - 1] : 0
      }

      if (counts.length === 1) {
        return 0
      }

      if (counts.length > 1) {
        return counts[counts.length - 1] - counts[0]
      }

      return null
    },

    getFirstValueExceptNull(analytics: any[], value: string) {
      const data = analytics.find(analytic => analytic[value] !== null)

      if (!data) {
        return 0
      }

      return data[value]
    },

    getLastValue(analytics: any[], value: string) {
      const data = analytics.filter(analytic => analytic[value] !== null)

      if (data.length === 0) {
        return null
      }

      return data[data.length - 1][value]
    },

    getValueByPeriod(analytics: any[], value: string): number | null {
      const data = analytics.filter(analytic => analytic[value] !== null)

      if (data.length === 0) {
        return null
      }

      // If there is only one period, return last value
      if (analytics.length === this.data.length) {
        return data[data.length - 1][value]
      }

      // If this is the first period, return first value
      if (moment(analytics[0].datetime).isSame(this.data[0].datetime)) {
        return data[0][value]
      }

      return data[data.length - 1][value]
    },

    getValueByHour(analytics: any[], datetime: string, value: string) {
      const data = analytics.find(analytic => moment(analytic.datetime).isSame(datetime, 'hour'))

      if (!data) {
        return null
      }

      return data[value]
    },

    /**
     * キャンペーン分析公開フラグを更新する
     */
    async changePublicAnalyticsFlags(value: string) {
      TrackingService.sendEvent(
        `click:キャンペーン分析（X）|${value === '分析結果の共有' ? '分析結果の共有' : 'APIとして公開'}`
      )

      const params: any = {
        isPublicAnalyticsPage: this.isPublicAnalyticsPage,
        isPublicAnalyticsApi: this.isPublicAnalyticsApi
      }

      const result = await api.put(`campaigns/${this.campaignId}/publics`, params)

      if (!result.data) {
        this.$notify({
          title: 'キャンペーン分析公開フラグの変更に失敗しました。',
          message: '',
          customClass: 'danger',
          duration: 5000
        })
      }
    },

    /**
     * クリップボードにコピーする
     */
    copyToClipboard(text: string) {
      Util.copyToClipboard(text)
      this.$message({
        message: 'クリップボードにURLをコピーしました。',
        type: 'success'
      })
    },

    /**
     * エラー通知
     */
    alert() {
      this.$notify({
        title: 'キャンペーン分析の取得に失敗しました。',
        message: '恐れ入りますが、時間をおいて再度お試しください。',
        customClass: 'danger',
        duration: 5000
      })
    },

    changeTab() {
      if (this.activeTab === 'campaigns') {
        TrackingService.sendEvent('click:キャンペーン分析（X）|キャンペーン')
      } else TrackingService.sendEvent('click:キャンペーン分析（X）|応募者のフォロワー数')
    },

    changeIsBeginAtZero() {
      TrackingService.sendEvent('switch:キャンペーン分析（X）|キャンペーン|0から表示')
    }
  }
})
</script>
